













import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

@Component
export default class BaseTLCheckBox extends Vue {
	@Prop({ type: String, required: true, default: "" }) label?: string; //hlavní popis
	@Prop({ type: String, required: false, default: "" }) id?: string; //id
	@Prop({ type: String, required: false, default: "" }) name?: string; //name
	@Prop({ type: Boolean, required: false, default: null }) state?: boolean; //stav červeny a zeleny
	@Prop({ type: Boolean, required: false, default: null }) checked?: boolean; //checked vybrano
	@Prop({ type: Boolean, required: false, default: false }) useSwitch?: boolean; //zobrazit jako přepínač
	@Prop({ type: Boolean, required: false, default: false }) isBig?: boolean; //větší pismo
	@Prop({ type: Boolean, required: false, default: false }) readonly?: boolean; //needitovalné checkbox
	@Prop({ type: undefined, required: false, default: false }) value?: any; //needitovalné checkbox
	@Prop({ type: Boolean, required: false, default: false }) inter?: boolean; //checkbox mezistav	

	//načtení stylu
	get inputClass() {
		return {
			"checkbox-design": true,
			"checkbox-design-bigger": this.isBig

		};
	}
}
